/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_New_Pick_PeopleInputs */

const cs_chat_new_pick_people = /** @type {(inputs: Chat_New_Pick_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat lidi`)
};

const en_chat_new_pick_people = /** @type {(inputs: Chat_New_Pick_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add people`)
};

/**
* | output |
* | --- |
* | "Add people" |
*
* @param {Chat_New_Pick_PeopleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_new_pick_people = /** @type {((inputs?: Chat_New_Pick_PeopleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_New_Pick_PeopleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_new_pick_people(inputs)
	return cs_chat_new_pick_people(inputs)
});